import { IPromise, IQService } from 'angular';
import { IClientCart, IDjangoCart, IDjangoCartPost } from '../../tn.common';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';

export class CartRepository {
    static $inject = ['djangoClient', '$q'];
    constructor(
        protected djangoClient: DjangoClient,
        protected $q: IQService
    ) {}

    checkForBadLicenses(localCart: IClientCart): void {
        if (localCart.license && localCart.license.length > 0) {
            localCart.license.forEach((license) => {
                // we dropped free licenses, so if we find one reset it to unlicensed.
                if (
                    license.fontRights.web.views === 10000 &&
                    (license.fontRights.web.years === null ||
                        (license.fontRights.web.years as number | 'free_trial' | 'unlimited') === 'free_trial')
                ) {
                    // remove legacy free web hosted license.
                    license.fontRights.web.views = null;
                    license.fontRights.web.years = null;
                    license.fontRights.web.self_hosted = false;
                }
            });
        }
    }

    listCarts(): IPromise<IClientCart[]> {
        return this.djangoClient
            .getAllPages<IDjangoCart>('/api/1/carts/')
            .then((data) => this._transformServerCartsToClient(data.results));
    }

    getCart(id: number): IPromise<IClientCart> {
        return this.djangoClient
            .get<IDjangoCart>(`/api/1/carts/${id}/`)
            .then((data) => this._transformCartToClient(data));
    }

    emailSavedCart(email: string, id: number): IPromise<void> {
        return this.djangoClient.post(`/api/1/carts/${id}/email/${email}/`);
    }

    saveCart(cart: IClientCart): IPromise<IClientCart> {
        return this.djangoClient
            .post<IDjangoCart, IDjangoCartPost>(
                '/api/1/carts/',
                this._transformCartToServer(cart)
            )
            .then((data) => this._transformCartToClient(data));
    }

    updateCart(cart: IClientCart): IPromise<IClientCart> {
        const url = `/api/1/carts/${cart.id}/`;
        return this.djangoClient
            .put<IDjangoCart, IDjangoCartPost>(
                url,
                this._transformCartToServer(cart)
            )
            .then((data) => this._transformCartToClient(data));
    }

    deleteCart(cart: IClientCart): IPromise<void> {
        if (cart.id !== undefined && cart.id !== null) {
            return this.djangoClient.del(`/api/1/carts/${cart.id}/`);
        }
        return this.$q.when();
    }

    _transformCartToServer(clientCart: IClientCart): IDjangoCart {
        const name = clientCart.title;
        const id = clientCart.id;
        const license = clientCart.license;
        const user = clientCart.user;

        const toServer: IDjangoCart = {
            name,
            id,
            cart_data: {
                license,
            },
            date: '',
            user,
        };
        return toServer;
    }

    _transformServerCartsToClient(carts: IDjangoCart[]): IClientCart[] {
        return carts.map((c) => this._transformCartToClient(c));
    }

    _transformCartToClient(serverCart: IDjangoCart): IClientCart {
        const id = serverCart.id;
        const title = serverCart.name;
        const date = new Date(serverCart.date);
        const user = serverCart.user;
        const cart_data = serverCart.cart_data;

        const toClient = {
            ...cart_data,
            id,
            title,
            date,
            user,
        };
        this.checkForBadLicenses(toClient);
        return toClient;
    }
}
